module.exports = __webpack_public_path__ + "static/zhouheiya-5600a81aeca3d7de9e88c8330c8ce051.png";